document.addEventListener("DOMContentLoaded", function () {
  const linksNofollow = document.querySelectorAll('a[target="_blank"]:not([rel="nofollow"])');
  linksNofollow.forEach((link) => {
    link.setAttribute("rel", "nofollow");
  });

  document.body.addEventListener("click", function (event) {
    const showCodeButton = event.target.closest("button.casino-code_show");

    if (showCodeButton) {
      const inPageModal = document.querySelectorAll("#modal-coupon");
      const entityId = showCodeButton.getAttribute("data-id");
      const entityType = showCodeButton.getAttribute("data-type");
      const urlParams = new URLSearchParams({
        action: `code_modal`,
        nonce: typeof main !== "undefined" ? main.ajaxPublicNonce : "",
        entity: entityId,
        entityType: entityType,
      });

      inPageModal.forEach((modal) => modal.remove());

      showCodeButton.classList.add("in-proccess");
      showCodeButton.setAttribute("disabled", "true");

      const ajaxUrl = typeof main !== "undefined" ? main.ajaxUrl : "";

      fetch(`${ajaxUrl}?${urlParams}`, {
        method: "GET",
        headers: { "Content-Type": "application/json; charset=utf-8" },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Network Error");
          return res.json();
        })
        .then((response) => {
          if (response.success && response.data.code_modal) {
            document.body.classList.add("no-scroll");
            document.body.insertAdjacentHTML("afterbegin", response.data.code_modal);
          }
        })
        .catch((error) => console.error("Fetch error:", error))
        .finally(() => {
          showCodeButton.removeAttribute("disabled");
          showCodeButton.classList.remove("in-proccess");
        });
      return;
    }

    const searchList = document.getElementById("search-list");
    const headerSearch = document.querySelector(".header_search");

    if (
      searchList && headerSearch &&
      searchList.style.display === "block" &&
      !searchList.contains(event.target) &&
      !headerSearch.contains(event.target)
    ) {
      searchList.style.display = "none";
    }
  });

  const reviewButton = document.querySelector(".btn-review");
  if (reviewButton) {
    reviewButton.addEventListener("click", function (e) {
      e.preventDefault();
      const reviewForm = document.querySelector(".review_add");
      if (reviewForm) {
        reviewForm.style.display = "block";
        requestAnimationFrame(() => {
          const top = reviewForm.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top, behavior: "smooth" });
        });
      }
    });
  }

  const cancelButton = document.getElementById("cancel-review");
  const reviewForm = document.querySelector("form.review_add");
  if (cancelButton && reviewForm) {
    cancelButton.addEventListener("click", () => {
      reviewForm.style.display = "none";
    });
  }

  const replyButtons = document.querySelectorAll(".reply-icon");
  replyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      if (!document.body.classList.contains("logged-in")) {
        const loginModal = document.getElementById("modal-login");
        if (loginModal) loginModal.classList.add("open");
      }
    });
  });

  const reviewLink = document.querySelector(".write-review");
  if (reviewLink) {
    reviewLink.addEventListener("click", function (event) {
      event.preventDefault();
      const targetElement = document.querySelector("#reviews-scroll");
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  }

  const modal = document.getElementById("modal-confirmation");
  const buttons = document.querySelectorAll(".modal_btns .btn");
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      if (modal) modal.classList.remove("open");
      document.cookie = "ageConfirmed=true; max-age=" + 3 * 24 * 60 * 60;
    });
  });

  document.querySelectorAll(".casino-card--bonuse .head .country").forEach((country) => {
    if (country.querySelector(".forbidden")) {
      country.classList.add("has-forbidden");
    } else {
      country.classList.remove("has-forbidden");
    }
  });

  const linksAddInf = document.querySelectorAll("a[href^='#']:not([href='#'])");
  linksAddInf.forEach((link) => {
    link.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        e.preventDefault();
        requestAnimationFrame(() => {
          const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - 150;
          window.scrollTo({ top: offsetTop, behavior: "smooth" });
        });
      }
    });
  });

  const arrows = document.querySelectorAll(".chart-arrow");
  if (arrows.length > 0) {
    let cssRules = "";
    arrows.forEach((arrow) => {
      const value = parseInt(arrow.getAttribute("data-value"), 10);
      if (!isNaN(value)) {
        const degrees = (value - 50) * 1.8;
        cssRules += `.chart-arrow[data-value="${value}%"]::before {transform: rotate(${degrees}deg);}\n`;
      }
    });
    const style = document.createElement("style");
    style.innerHTML = cssRules;
    document.head.appendChild(style);
  }

  const tagsWrapper = document.querySelector(".tags");
  if (tagsWrapper) {
    const firstTagItem = document.querySelector(".tags_list li:first-child");
    const tagsSelected = document.querySelector(".tags_selected");

    if (firstTagItem && tagsSelected) {
      firstTagItem.style.display = "none";
      tagsSelected.textContent = firstTagItem.querySelector("a").textContent;
    }

    const tagsLinks = document.querySelectorAll(".tags_list a");
    tagsLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        tagsSelected.textContent = this.textContent;
        const parentLi = this.parentElement;
        parentLi.style.display = "none";

        Array.from(parentLi.parentElement.children).forEach((sibling) => {
          if (sibling !== parentLi) sibling.style.display = "";
        });
      });
    });

    tagsWrapper.addEventListener("click", () => tagsWrapper.classList.toggle("open"));

    document.addEventListener("click", (e) => {
      if (!tagsWrapper.contains(e.target)) {
        tagsWrapper.classList.remove("open");
      }
    });
  }

  if (typeof main === "undefined" || !main?.isIntentModalDisabled) {
    initExitIntent();
  }
});

const intentPopupOverlay = document.getElementById("exit-intent");
const intentPopupCloseBtn = document.getElementById("exit-intent__close");
const intentPopupCtaBtns = document.querySelectorAll(".exit-intent__cta");

const cookieLifetime = typeof main !== "undefined" && main?.intentModalCookieLifetime ? main.intentModalCookieLifetime : 1;

const intentPopupConfig = {
  cookieName: "exit_popup_seen",
  cookieDays: cookieLifetime,
  mouseTreshold: 25,
  delay: 0,
  touchScrollTriggerPct: 0.6,
  fastScrollSpeedThreshold: 1.5,
  idleTimeMs: 20000,
};

let popupShown = false;
let popupShowTimeout = null;
let popupIdleTimer = null;
let historyPushed = false;
let isScrolling = false;

let lastScrollY = 0;
let lastScrollTime = Date.now();
let scrolledDown = false;
let cachedPageHeight = 1;

const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 864e5);
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
};

const getCookie = (name) => {
  return document.cookie.split(";").some((c) => c.trim().startsWith(`${name}=`));
};

const showIntentPopup = () => {
  if (popupShown || getCookie(intentPopupConfig.cookieName)) return;

  popupShowTimeout = setTimeout(() => {
    popupShown = true;
    if (intentPopupOverlay) intentPopupOverlay.classList.add("is-active");
    document.body.classList.add("no-scroll");
    removePopupListeners();
  }, intentPopupConfig.delay);
};

const hideIntentPopup = ({ permanent = false } = {}) => {
  clearTimeout(popupShowTimeout);
  if (intentPopupOverlay) intentPopupOverlay.classList.remove("is-active");
  document.body.classList.remove("no-scroll");

  if (permanent) {
    setCookie(intentPopupConfig.cookieName, "1", intentPopupConfig.cookieDays);
  }
};

const onMouseMove = (e) => {
  if (e.clientY <= intentPopupConfig.mouseTreshold) {
    showIntentPopup();
  } else {
    clearTimeout(popupShowTimeout);
  }
};

const onMouseLeave = (e) => {
  if (e.clientY <= intentPopupConfig.mouseTreshold || e.clientY <= 0) {
    showIntentPopup();
  }
};

const updateCachedHeight = () => {
  requestAnimationFrame(() => {
    if (document.body) {
      cachedPageHeight = Math.max(document.body.scrollHeight - window.innerHeight, 1);
    }
  });
};

const onScrollEvent = () => {
  if (!isScrolling) {
    window.requestAnimationFrame(() => {
      const scrollY = window.scrollY;
      const currentTime = Date.now();
      const timeDiff = currentTime - lastScrollTime;
      const scrollDiff = lastScrollY - scrollY;

      if (timeDiff > 0 && scrollDiff > 0) {
        const scrollSpeed = scrollDiff / timeDiff;
        if (scrollSpeed > intentPopupConfig.fastScrollSpeedThreshold) {
          showIntentPopup();
        }
      }

      if (!scrolledDown && scrollY / cachedPageHeight > intentPopupConfig.touchScrollTriggerPct) {
        scrolledDown = true;
      }

      if (scrolledDown && scrollY < lastScrollY && scrollY / cachedPageHeight < 0.2) {
        showIntentPopup();
      }

      lastScrollY = scrollY;
      lastScrollTime = currentTime;
      isScrolling = false;
    });
    isScrolling = true;
  }
};

const onPopState = () => showIntentPopup();

const pushHistoryState = () => {
  if (!historyPushed) {
    history.pushState({ exitIntent: true }, null, window.location.href);
    historyPushed = true;
    window.addEventListener("popstate", onPopState);

    ["touchstart", "click", "mousemove"].forEach((event) => {
      document.removeEventListener(event, pushHistoryState);
    });
  }
};

const resetIdleTimer = () => {
  clearTimeout(popupIdleTimer);
  if (!popupShown) {
    popupIdleTimer = setTimeout(() => {
      showIntentPopup();
    }, intentPopupConfig.idleTimeMs);
  }
};

const onKeyDown = (e) => {
  if (e.key === "Escape" && popupShown) {
    hideIntentPopup({ permanent: true });
  }
};

const onOverlayClick = (e) => {
  if (e.target === intentPopupOverlay) {
    hideIntentPopup({ permanent: false });
  }
};

const removePopupListeners = () => {
  document.removeEventListener("mousemove", onMouseMove);
  document.removeEventListener("mouseleave", onMouseLeave);
  window.removeEventListener("scroll", onScrollEvent);
  window.removeEventListener("resize", updateCachedHeight);
  window.removeEventListener("popstate", onPopState);

  clearTimeout(popupIdleTimer);
  ["touchstart", "mousemove", "scroll", "click", "keydown"].forEach((event) => {
    document.removeEventListener(event, resetIdleTimer);
  });

  ["touchstart", "click", "mousemove"].forEach((event) => {
    document.removeEventListener(event, pushHistoryState);
  });
};

const initExitIntent = () => {
  if (getCookie(intentPopupConfig.cookieName) || !intentPopupOverlay) return;

  if (intentPopupCloseBtn) {
    intentPopupCloseBtn.addEventListener("click", () => hideIntentPopup({ permanent: true }));
  }

  intentPopupOverlay.addEventListener("click", onOverlayClick);
  document.addEventListener("keydown", onKeyDown);

  intentPopupCtaBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      setCookie(intentPopupConfig.cookieName, "1", intentPopupConfig.cookieDays);
    });
  });

  requestAnimationFrame(() => {
    lastScrollY = window.scrollY;
    updateCachedHeight();
  });

  window.addEventListener("resize", updateCachedHeight, { passive: true });
  document.addEventListener("mousemove", onMouseMove, { passive: true });
  document.addEventListener("mouseleave", onMouseLeave, { passive: true });
  window.addEventListener("scroll", onScrollEvent, { passive: true });

  ["touchstart", "click", "mousemove"].forEach((event) => {
    document.addEventListener(event, pushHistoryState, { passive: true });
  });

  ["touchstart", "mousemove", "scroll", "click", "keydown"].forEach((event) => {
    document.addEventListener(event, resetIdleTimer, { passive: true });
  });

  resetIdleTimer();
};
